module.exports = __webpack_public_path__ + "static/media/lunch.3848c6cf.svg";